import Konva from 'konva';
import { createRef } from 'react';

import type { IVisible } from '../CseMachineTypes';

/**
 * class to implement the IVisible interface, used by all components.
 */
export abstract class Visible implements IVisible {
  protected _x: number = 0;
  protected _y: number = 0;
  protected _width: number = 0;
  protected _height: number = 0;
  protected _isDrawn: boolean = false;
  x(): number {
    return this._x;
  }
  y(): number {
    return this._y;
  }
  width(): number {
    return this._width;
  }
  height(): number {
    return this._height;
  }
  isDrawn(): boolean {
    return this._isDrawn;
  }
  reset(): void {
    this._isDrawn = false;
  }
  setShapesStyle(color: string): void {
    const shapes = this.ref.current?.getChildren?.() ?? [];
    shapes.forEach((shape: Konva.Node) => {
      if (shape instanceof Konva.Shape) {
        if (shape.attrs.stroke) {
          shape.stroke(color);
        }
        if (shape.attrs.fill) {
          shape.fill(color);
        }
      }
    });
  }
  public ref: React.RefObject<any> = createRef();
  protected get tag() {
    return this.ref.current?.getChildren?.()[0];
  }
  protected get secItem() {
    return this.ref.current?.getChildren?.()[1];
  }
  setArrowSourceHighlightedStyle(): void {}
  setArrowSourceNormalStyle(): void {}
  abstract draw(key?: number): React.ReactNode;
}
